var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import MarqueeIfOverflow from "./MarqueeIfOverflow";
import { ArrowRight } from "lucide-react";
var getSaldoBgColor = function (dias) {
    if (dias === undefined || dias === null)
        return "bg-gradient-to-r from-gray-800 to-gray-800";
    if (dias > 0 && dias < 3)
        return "bg-orange-600";
    if (dias >= 3 && dias < 6)
        return "bg-[#8f5600]";
    return "bg-gradient-to-r from-gray-800 to-gray-800";
};
var MetricItem = function (_a) {
    var label = _a.label, value = _a.value, _b = _a.color, color = _b === void 0 ? '#ffffff' : _b, _c = _a.size, size = _c === void 0 ? 'normal' : _c, _d = _a.classAdd, classAdd = _d === void 0 ? null : _d, daysRemaining = _a.daysRemaining, link = _a.link, _e = _a.disableZeroBlink, disableZeroBlink = _e === void 0 ? false : _e, _f = _a.account_stopped, account_stopped = _f === void 0 ? false : _f, minWidth = _a.minWidth // NOVO
    ;
    var sizeClasses = {
        small: 'text-[11px] 2xl:text-sm',
        normal: 'text-xs xl:text-sm 2xl:text-base',
        large: 'text-sm xl:text-base 2xl:text-lg',
    };
    var roundedDays = typeof daysRemaining === "number" ? Math.floor(daysRemaining) : undefined;
    var isZero = value === '0' ||
        value === 'R$ 0' ||
        value === 'R$ 0,00' ||
        /\|\s*0\s*dia/.test(String(value)) ||
        value == "| 0 dia";
    var isZeroOrStopped = isZero || account_stopped;
    var bgClass = !isZeroOrStopped && daysRemaining !== undefined
        ? getSaldoBgColor(daysRemaining)
        : (isZeroOrStopped
            ? (disableZeroBlink ? 'bg-gradient-to-r from-gray-800 to-gray-800' : 'metric-zero blink')
            : 'bg-gradient-to-r from-gray-800 to-gray-800');
    return (React.createElement("div", { className: "pt-0.5 pb-0.5 pr-1 2xl:pr-2.5 pl-1 2xl:pl-2.5 rounded border border-gray-700/30 shadow-sm flex flex-col justify-between h-full text-white-fallback " +
            bgClass +
            (classAdd ? " ".concat(classAdd) : '') +
            (link ? ' cursor-pointer hover:shadow-md hover:border-blue-500/50 transition-all' : ' cursor-default'), title: account_stopped
            ? "ATENÇÃO: conta sem atividade desde a ultima atualização."
            : null, style: minWidth ? __assign({ minWidth: minWidth }, ((typeof minWidth === "number") ? { maxWidth: minWidth } : {})) : undefined, onClick: link ? function () { return window.open(link, '_blank'); } : undefined },
        React.createElement("div", { className: "text-[10px] 2xl:text-xs text-gray-400 mb-1 flex items-center justify-between overflow-hidden" },
            label,
            link && (React.createElement("a", { href: link, target: "_blank", rel: "noopener noreferrer", className: " px-0 2xl:px-1 rounded-full hover:bg-blue-600/20 transition flex items-center justify-center", title: "Acessar", style: { lineHeight: 0 } },
                React.createElement(ArrowRight, { className: "w-4 h-4 text-blue-400 " })))),
        React.createElement("div", { className: "font-medium ".concat(sizeClasses[size], " truncate"), style: { color: isZeroOrStopped ? 'white' : color } },
            React.createElement(MarqueeIfOverflow, null, typeof value === "string" && value.includes("dias") && roundedDays !== undefined
                ? value.replace(/(\d+)([.,]?\d*)\s*dias/, "".concat(roundedDays, " dias"))
                : value))));
};
export default MetricItem;
